module.exports = "https://cdn.thelire.com/ins/resource/ico_tab5_exclusivevipdiscount@3x.fd1a5873da397cbc06944ebea59e425f.png";